import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/transaction/user-authorizes'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        saveAuthorize(context, { data, config }) {
            return base.request.put(`${baseUrl}/authorize`, data, { ...config });
        },
        updateStatus(context, { data, config }) {
            return base.request.put(`${baseUrl}/status`, data, { ...config });
        },
    },
    mutations: {
        ...base.mutations
    },
}
